export default "/_next/static/images/Google_AI_Studio_2025-12-06T00_24_50.650Z 14-df73577aaea7cdbe77cda6c095bd793c.png";